<template>
  <!-- 邮编选择 -->
  <mt-popup
             v-model="show"
             class="popup-ui"
             position="bottom"
             :teleport="teleport"
             :closeOnClickModal='false'
             :round="true">
    <div class="popup-container">
      <div class="popup-top">
        <span class="title"
              :style="[{ textAlign: titleAlign || 'center' }]">{{ title }}</span>
        <i class="iconfont icon-close"
           @click="() => { $emit('close'); $emit('change', false) }" />
      </div>
      <div class="popup-main">
        <div class="top-search">
          <div class="search-input">
            <i class="iconfont icon-search btn-search" :class="PostUiIcon.search" />
            <input ref="searchInput"
                   v-model="inputValue"
                   type="text"
                   placeholder="请输入邮政编码"
                   @keyup="handleInput('up')"
                   @keydown="handleInput('down')">
            <i v-show="inputValue"
               class="iconfont icon-close-circle btn-clear"
               @click.stop="() => { inputValue = ''; handleInput('up') }" />
          </div>
          <button v-if="inputValue"
                  type="button"
                  class="btn-confirm"
                  @click="handleConfirm()">
            确定
          </button>
          <!-- <button v-else
                  type="button"
                  class="btn-confirm"
                  @click="handleCancel()">
            取消
          </button> -->
        </div>

        <div class="cascader-list">
          <div v-for="(item, index) in list"
               :key="index"
               class="cascader-item"
               :class="{ 'active': isActiveItem(item) }"
               @click="handleItemClick(item)">
            <div class="cascader-name">
              <span v-html="highlightText(item, inputValue)"></span>
            </div>
            <i class="iconfont"
               :class="isActiveItem(item) ? 'icon-check-circle' : 'icon-check-button-off'" />
          </div>
          <!-- 缺省图 -->
          <div v-if="!list.length" class="result-wrapping">
            <no-result-box  resultNull="暂无相关数据～"></no-result-box>
          </div>
        </div>
      </div>
      <div v-if="confirmBtn"
           class="popup-bottom">
        <button type="button"
                class="confirm-btn"
                @click="$emit('confirm')">
          {{ confirmBtnText }}
        </button>
      </div>
    </div>
  </mt-popup>
</template>
<script>
import { Popup } from 'mint-ui'
import NoResultBox from '@/components/noResult/NoResultBox.vue'
import { highlightText } from '@/plugin/commonUse.js'

let timer = null

export default {
  name: 'customPopup',
  mixins: [],
  components: {
    NoResultBox,
    'mt-popup': Popup
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    confirmBtn: {
      type: Boolean,
      default: true
    },
    confirmBtnText: {
      type: String,
      default: ''
    },
    safeAreaInsetBottom: {
      type: Boolean,
      default: true
    },
    titleAlign: {
      type: String,
      default: 'center'
    },
    teleport: {
      type: String,
      default: ''
    },
    /** 数据列表 */
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectItem: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      popupVisible: false,
      isSearchResult: false,
      inputValue: ''
    }
  },
  computed: {
    highlightText () {
      return highlightText
    }
  },
  watch: {
    show (val) {
      this.popupVisible = val
      if (!val) {
        this.$emit('change', false)
        this.$emit('close')
      }
    }
  },
  filters: {},
  directives: {},
  created () {},
  mounted () {},
  methods: {
    handleInput (type) {
      switch (type) {
        case 'down':
          window.clearTimeout(timer)
          break
        case 'up':
          timer = setTimeout(() => {
            this.$emit('input', this.inputValue)
          }, 500)
          break
        default:
          break
      }
    },
    isActiveItem (item) {
      if (item === this.selectItem || item?.commodityCode === this.selectItem) {
        return true
      }
      return false
    },
    handleConfirm () {
      this.$emit('change', false)
      this.$emit('handelClick', this.inputValue)
      this.inputValue = ''
      this.handleInput('up') // 恢复选择列表
    },
    handleItemClick (item) {
      this.$emit('change', false)
      this.$emit('handelClick', item)
      this.inputValue = ''
      this.handleInput('up') // 恢复选择列表
      // this.$emit('close')
    }
  }
}

</script>
<style lang="scss" scoped>
.popup-ui {
  width: 100%;
  border-radius: torem(8px) torem(8px) 0 0;
  // height: 80vh;
}

.popup-container {
  display: flex;
  width: 100%;
  height: 85vh;
  flex-direction: column;
  // background-color: $color-bg-page;
  background-color: #fff;
  border-radius: torem(8px) torem(8px) 0 0;

  .popup-top {
    position: relative;
    display: flex;
    height: torem(50px);
    min-height: torem(50px);
    align-items: center;
    justify-content: space-between;
    padding: 0 torem(14px);
    background-color: #fff;
    border-radius: torem(8px) torem(8px) 0 0;
  }

  .title {
    flex: 1;
    font-size: torem(16px);
    font-weight: 600;
    text-align: center;
  }

  .icon-close {
    position: absolute;
    right: torem(14px);
    color: #999;
    font-size: torem(24px);
  }

  .popup-main {
    display: flex;
    height: 100%;
    flex: 1;
    flex-direction: column;
    overflow-y: auto;
  }

  .popup-bottom {
    display: flex;
    justify-content: space-between;
    padding: torem(8px) torem(14px) calc(38px * 2);
    background-color: #fff;
    box-shadow: 0 torem(2px) torem(10px) 0 rgba(0, 0, 0, 0.08);

    button {
      height: torem(44px);
      flex: 1;
      border-radius: torem(44px);
      color: #fff;
      font-size: torem(16px);
    }

    .confirm-btn {
      background-color: #ff9000;
    }
  }
}

.result-wrapping {
  padding: torem(14px);
}

// 业务
.top-search {
  display: flex;
  width: 100%;
  height: torem(50px);
  flex-shrink: 0;
  justify-content: space-between;
  padding: torem(10px) torem(14px);
  background: #fff;

  .search-input {
    display: flex;
    height: 100%;
    flex: 1;
    align-items: center;
    padding: 0 torem(14px);
    background: #f9f9f9;
    border-radius: torem(30px);
    font-size: torem(12px);

    input[type='text'] {
      flex: 1;
      background: transparent;
      caret-color: #ff9000;

      &::-webkit-input-placeholder {
        font-size: torem(12px);
      }
    }

    .btn-clear {
      margin-left: torem(3px);
      color: #999;
      font-size: torem(20px);
    }

    .btn-search {
      margin-right: torem(2px);
      color: $searchIcon;
      font-size: torem(18px);
    }
  }

  .btn-confirm {
    min-width: torem(28px);
    margin-left: torem(10px);
    color: #ff9000;
    font-size: torem(14px);
  }
}

.tip-no-data {
  margin-top: torem(30px);
  font-size: torem(14px);
  text-align: center;
}

.cascader-list {
  // min-height: torem(467px);
  flex: 1;
  padding: 0 torem(14px);
  padding-bottom: torem(30px);
  overflow-y: auto;

  .cascader-item {
    @include setOnePx('bottom', #eee);

    display: flex;
    min-height: torem(50px);
    align-items: center;
    justify-content: space-between;
    padding: torem(5px) 0;

    .cascader-name {
      display: flex;
      font-size: torem(14px);
      line-height: torem(20px);

      .item-index {
        display: inline-block;
        width: torem(10px);
        height: torem(20px);
        margin-right: torem(10px);
        color: #999 !important;
      }

      .name-code {
        display: flex;
        min-width: torem(100px);
        align-items: center;
        margin-right: torem(10px);
      }

      .name-text {
        @include multiLineEllipsis(1);
      }
    }

    .iconfont {
      font-size: torem(20px);
    }

    .icon-check-button-off {
      color: #eee;
    }

    &.active {
      .cascader-name {
        color: #ff9000;
      }

      .iconfont {
        color: #ff9000;
      }
    }
  }
}
</style>
